<template>
    <card class="u-text-center">
        <el-progress
            type="dashboard"
            :color="colors"
            :percentage="100"
            stroke-linecap="butt"
            :format="format"
        />

        <p v-if="nextInspection" :class="`u-small-caps text-${status}`">
            Fällig am {{ $date(ensureDate(nextInspection), 'dd.MM.yyyy') }}.
        </p>
        <p v-if="type !== 'dashboard'" class="mt-4 u-small-caps">
            Letzte am: {{ $date(ensureDate(lastInspection), 'dd.MM.yyyy') }}
        </p>
    </card>
</template>

<script>
import { head, isEmpty, prop } from 'ramda'
import add from 'date-fns/add'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import { isWarning, isDanger } from '@/lib/inspections'
import Card from '@/components/Card'
import { parseISO } from 'date-fns'

export default {
    components: { Card },

    props: {
        dates: { type: Array, required: true },
        type: { type: String, default: '', validator: val => ['', 'dashboard'].includes(val) },
        forcedLabel: { type: String, default: '' },
        interval: { type: Object, required: true },
        warningDiff: { type: Number, required: true }, // In days
        dangerDiff: { type: Number, required: true }, // In days
    },

    computed: {
        lastInspection () {
            if (isEmpty(this.dates)) return null

            return prop('date', head(this.dates))
        },

        nextInspection () {
            if (!this.lastInspection) return null

            const addedDays = add(this.ensureDate(this.lastInspection), this.interval)

            return new Date(addedDays)
        },

        status () {
            if (isDanger(this.lastInspection, this.nextInspection, this.dangerDiff)) {
                return 'exception'
            }
            if (isWarning(this.lastInspection, this.nextInspection, this.warningDiff)) {
                return 'warning'
            }

            return 'success'
        },

        colors () {
            const colors = {
                warning: '#e6a23c',
                exception: '#fe413c',
                success: '#5cb87a',
            }
            return [{ color: colors[this.status], percentage: '0' }]
        },

        format () {
            if (this.type === 'dashboard') {
                return () => this.forcedLabel
            }

            let diff = 0
            if (this.lastInspection && this.nextInspection) {
                diff = differenceInCalendarDays(this.ensureDate(this.nextInspection), this.ensureDate(this.lastInspection))
            }

            if (diff === 0) {
                return () => '...'
            }

            let agoLabel = this.$timeAgo.format(this.nextInspection, 'round')
            agoLabel = agoLabel.replace(/Monaten/, 'Mon.')
            agoLabel = agoLabel.replace(/vor/, 'seit')

            return () => agoLabel
        },
    },

    methods: {
        ensureDate (date) {
            if (typeof date !== 'string') return date

            return parseISO(date)
        },
    },
}
</script>

<style lang="scss" scoped>
.date-item {
    margin: 0 (-$spacing-unit-16) $spacing-unit-8;
    user-select: none; /* Disable text selection */
}

/deep/ .el-progress__text {
    color: rgba($white, 0.7) !important;
    font-size: $font-size-20 !important;
    font-variant: all-small-caps;
}
</style>
